import React , { useCallback } from 'react';
import { useForm } from '~/hooks';
import { useValidation } from '~/hooks/useValidation';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import { useSectionLoader } from '../../hooks';
import sectionTypes from '../sectionTypes';

/**
 * @typedef TaxesReviewValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId * 
 * @typedef FormState
 * @property {TaxesReviewValues} values The current form values
 */

/** @type {TaxesReviewValues} */

const defaultState = {
    sectionId: 0
};

const validationSchema = {
    taxesPaidThrough: {}
};

const TaxesReview = ({ titleOpinionId , validate , validationResult }) => {
    const { onLoad: loadSection } = useSectionLoader(sectionTypes.TAXES_ASSESMENTS, titleOpinionId);

    const onLoad = useCallback((values) => {
        return loadSection(values);
    }, [titleOpinionId]);

    const {
        /** @type {FormState} */
        state,
        //fieldActions
    } = useForm({
        /** @type {ReviewValues} */
        initialState: { ...defaultState },
        onLoad,
        debug: true
    });

    let errorSection = false;
    if ( validate ) {
        if(!state.values.sectionId) {
            errorSection= true;            
        } else {
            if(!Object.keys(state.values).includes('taxesPaidThrough')) {
                errorSection = true; 
            }
            if(!errorSection) {
                for (const [key, value] of Object.entries(state.values)) {
                    if(key !== 'additionalSection' && key !== 'orderNumber'
                        && key !== 'parcelId' && key !== 'taxesNowDuePayable' && key !== 'taxesNotDue' && key !== 'errorMessage' && (value === null || value === '')) {
                        errorSection = true;                    
                        break;
                    }
                }
            }
            
        }        
        validationResult(errorSection);
    }

    const [, invalidFields] = useValidation(state.values, validationSchema);

    return (
        
        <div className="ml-2 mr-5">
            {state.values.sectionId === 0 ? 
                <div />
                :
                <>
                    <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
                    <div className="text-1xl text-blue-60 font-bold mb-3">
                        <div className="display:flex; flex-direction:row;">
                            <div className="z-10 flex flex-row h-full  text-xs font-semibold text-blue-60">
                                <div className="mt-1 mb-2">2. <a href={`/StraightFinal/${titleOpinionId}/taxes`}>Taxes &amp; Special Assessments</a> </div>
                            </div> 
                            
                        </div>
                    </div>
                    <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-8 gap-y-1 text-xs mb-4">
                        <div className="col-span-8 text-red-600">
                            {errorSection ? 
                                <p className="flex flex-row gap-x-2 mb-2"><BsFillExclamationCircleFill />
                                    You have not provided all the required information in this section.</p>
                                : ''
                            }
                        </div>
                        <div className={`col-span-3 font-semibold ${invalidFields.taxesPaidThrough && 'text-red-600'}`}>Taxes have been paid through and include those for the year: </div>
                        <div className="col-span-1 flex-end">{state.values.taxesPaidThrough}</div>
                        <div className="col-span-3 font-semibold">Taxes, a lien, deffered, or otherwise, but not yet due and payable:</div>
                        <div className="col-span-1 flex-end">{state.values.taxesNotDue }</div>
                        <div className="col-span-3 font-semibold">Taxes now due and payable in the amount of: </div>
                        <div className="col-span-1 flex-end">{state.values.taxesNowDuePayable}</div>
                        <div className="col-span-3 font-semibold">Parcel ID/PIN/Tax Map ID:</div>
                        <div className="col-span-1 flex-end">{state.values.parcelId}</div>
                    </div>
                </>
            }   
        </div>
    );
};

export default TaxesReview;